import { render, staticRenderFns } from "./telaViewsDataCard.vue?vue&type=template&id=8649b4ac"
import script from "./telaViewsDataCard.vue?vue&type=script&lang=js"
export * from "./telaViewsDataCard.vue?vue&type=script&lang=js"
import style0 from "./telaViewsDataCard.vue?vue&type=style&index=0&id=8649b4ac&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports